var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceUnblur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "face_unblure__prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#face_unblure__prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.826.423q.56-.09 1.132-.09 1.078 0 2.103.318a.75.75 0 01-.19 1.466h-.032a.75.75 0 01-.223-.033q-.807-.251-1.658-.251-.451 0-.893.07a.75.75 0 01-.239-1.48zm-4.102 2.19q.786-.829 1.768-1.377a.75.75 0 11.731 1.31q-.782.436-1.41 1.099a.75.75 0 11-1.089-1.031zm10.278-1.325a.113.113 0 00-.202-.004l-.736 1.403-1.395.658a.113.113 0 00-.004.202l1.401.734.658 1.396c.04.084.16.087.203.004l.732-1.399 1.399-.66a.113.113 0 00.004-.202l-1.4-.733-.66-1.399zM.698 6.773q.173-1.116.648-2.131a.75.75 0 111.358.636q-.384.82-.523 1.724a.75.75 0 11-1.483-.23zm5.643.543V6.197a.75.75 0 00-1.5 0v1.12a.75.75 0 001.5 0zm4.733 0V6.197a.75.75 0 00-1.5 0v1.12a.75.75 0 101.5 0zM15.31 8q0-.573-.08-1.136a.75.75 0 00-.742-.644h-.004a.748.748 0 00-.746.75v.004c0 .034.002.068.007.102q.065.458.065.924 0 2.565-1.726 4.373-1.712 1.794-4.125 1.794h-.001q-.451 0-.893-.07a.75.75 0 10-.239 1.48q.56.09 1.132.09 3.055 0 5.211-2.258Q15.31 11.166 15.31 8zM1.346 11.358Q.87 10.343.698 9.228a.75.75 0 011.483-.23q.14.904.523 1.724a.75.75 0 11-1.358.636zm7.871-2.093q-.36.72-1.316.72-.955 0-1.315-.72a.75.75 0 00-.661-.415h-.01a.75.75 0 00-.75.748V9.6a.75.75 0 00.079.336q.775 1.55 2.657 1.55 1.883 0 2.658-1.55a.75.75 0 00.045-.56l-.004-.013a.75.75 0 00-.367-.429l-.01-.005a.75.75 0 00-.559-.045l-.013.005a.75.75 0 00-.43.367l-.004.009zm-4.725 5.5q-.982-.55-1.768-1.379a.75.75 0 011.09-1.03q.627.662 1.41 1.098a.75.75 0 11-.732 1.31z",
    fillRule: "evenodd",
    fill: "#414751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceUnblur);
export default __webpack_public_path__ + "static/media/face-unblur.75fe254ef7309c620e0b4dcb1a47e05c.svg";
export { ForwardRef as ReactComponent };